var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSalad(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#salad_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.854 33.75h.586a12.906 12.906 0 001.31-5.625c0-3.886-1.73-7.346-4.424-9.751C54.54 12.109 48.841 7.5 42 7.5c-.425 0-.826.09-1.243.125C38.672 3.134 34.148 0 28.875 0s-9.797 3.134-11.882 7.625c-.417-.035-.82-.125-1.243-.125a15 15 0 00-15 15c0 4.521 2.043 8.515 5.217 11.25h-3.32c-1.077 0-1.984.905-1.89 1.973.778 8.95 6.811 16.335 14.993 19.202v1.325A3.769 3.769 0 0019.525 60h22.529c2.074 0 3.696-1.68 3.696-3.75v-1.349c8.143-2.885 14.217-10.253 14.993-19.178.094-1.068-.813-1.973-1.89-1.973zM57 28.125c-.01 2.04-.7 4.02-1.958 5.625H40.208a9.2 9.2 0 01-1.958-5.625 9.375 9.375 0 1118.75 0zM4.5 22.5c0-4.117 2.695-12.279 15-11.25 3.266-7.468 7.65-7.5 9.375-7.5 1.662 0 6.094 0 9.375 7.5 4.11-.343 8.928-.129 12.422 4.143A12.981 12.981 0 0047.625 15 13.14 13.14 0 0034.5 28.125a12.924 12.924 0 001.3 5.625h-5.05V12.187a.938.938 0 00-.938-.937h-1.875a.938.938 0 00-.937.938v18.91L13.992 18.09a.938.938 0 00-1.325 0l-1.33 1.323a.937.937 0 000 1.326l13.008 13.007H15.75A11.263 11.263 0 014.5 22.5zm40.053 28.868L42 52.253v3.997H19.5v-3.984l-2.488-.88C10.724 49.184 6.11 43.86 4.804 37.5h51.892c-1.303 6.336-5.89 11.652-12.142 13.868z",
    fill: "#91C300"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "salad_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.75)",
    d: "M0 0h60v60H0z"
  })))));
}

export default SvgSalad;